export function isNullOrUndefined(value): value is null | undefined {
  return value === null || value === undefined;
}
